/**
 * Created by hoho on 2018. 7. 20..
 */
import TextViewTemplate from 'view/example/textviewTemplate';
import ViewTemplate from 'view/viewTemplate';
import HelpersTemplate from 'view/components/helpers/mainTemplate';
import BigButtonTemplate from 'view/components/helpers/bigButtonTemplate';
import ThumbnailTemplate from 'view/components/helpers/thumbnailTemplate';
import WaterMarkTemplate from 'view/components/helpers/waterMarkTemplate';
import MessageBoxTemplate from 'view/components/helpers/messageBoxTemplate';
import SpinnerTemplate from 'view/components/helpers/spinnerTemplate';
import ContextPanelTemplate from 'view/components/helpers/contextPanelTemplate';
import CaptionViewerTemplate from 'view/components/helpers/captionViewerTemplate';


import ControlsTemplate from 'view/components/controls/mainTemplate';
import VolumeButtonTemplate from 'view/components/controls/volumeButtonTemplate';
import ProgressBarTemplate from 'view/components/controls/progressBarTemplate';
import PlayButtonTemplate from 'view/components/controls/playButtonTemplate';
import SettingButtonTemplate from 'view/components/controls/settingButtonTemplate';
import FrameButtonsTemplate from 'view/components/controls/frameButtonsTemplate';
import TimeDisplayTemplate from 'view/components/controls/timeDisplayTemplate';
import FullScreenButtonTemplate from 'view/components/controls/fullScreenButtonTemplate';
import PanelsTemplate from 'view/components/controls/settingPanel/mainTemplate';
import SpeedPanelTemplate from 'view/components/controls/settingPanel/mainTemplate';
import SourcePanelTemplate from 'view/components/controls/settingPanel/mainTemplate';
import QualityPanelTemplate from 'view/components/controls/settingPanel/mainTemplate';
import AudioTrackPanelTemplate from 'view/components/controls/settingPanel/mainTemplate';
import CaptionPanelTemplate from 'view/components/controls/settingPanel/mainTemplate';
import TimeDisplayPanelTemplate from 'view/components/controls/settingPanel/mainTemplate';
import PlaylistPanelTemplate from 'view/components/controls/playlistPanelTemplate';

const Templates = {
    TextViewTemplate,
    ViewTemplate,
    HelpersTemplate,
    BigButtonTemplate,
    ThumbnailTemplate,
    WaterMarkTemplate,
    MessageBoxTemplate,
    SpinnerTemplate,
    ContextPanelTemplate,
    CaptionViewerTemplate,

    ControlsTemplate,
    VolumeButtonTemplate,
    ProgressBarTemplate,
    PlayButtonTemplate,
    SettingButtonTemplate,
    FrameButtonsTemplate,
    TimeDisplayTemplate,
    FullScreenButtonTemplate,
    PanelsTemplate,
    SpeedPanelTemplate,
    SourcePanelTemplate,
    QualityPanelTemplate,
    AudioTrackPanelTemplate,
    CaptionPanelTemplate,
    TimeDisplayPanelTemplate,
    PlaylistPanelTemplate
};

export default Templates;